import React from 'react';
import { Bed, Accessibility, Droplet, ShoppingCart } from 'lucide-react';

const AssetIcon = ({ type, size = 20, ...props }) => {
  const iconMap = {
    'bed': Bed,
    'wheelchair': Accessibility,
    'pump': Droplet,
    'trolley': ShoppingCart
  };

  const Icon = iconMap[type] || Bed;
  
  return <Icon size={size} {...props} />;
};

export default AssetIcon;
